import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  loadMembershipAgreementPDFRequest: ['payload'],
  loadMembershipAgreementPDFSuccess: ['pdfData'],
  loadMembershipAgreementPDFFailure: ['error'],

  loadMembershipReceiptPDFRequest: ['payload'],
  loadMembershipReceiptPDFSuccess: ['receiptPdfData'],
  loadMembershipReceiptPDFFailure: ['error'],
});

const Actions = {
  Types,
  Creators,
};

export default Actions;
